var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path5, _path6, _circle15, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _polygon2, _polygon3, _polygon4, _circle16, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 956.66997,
    height: 504.42139,
    viewBox: "0 0 956.66997 504.42139",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M908.57479,700.07025H299.189a46.35967,46.35967,0,0,1-46.30713-46.30664V540.37689A46.35969,46.35969,0,0,1,299.189,494.07022L908.57479,381.91684a46.35963,46.35963,0,0,1,46.30713,46.30667v225.5401A46.35974,46.35974,0,0,1,908.57479,700.07025Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 186.36926,
    y: 317.36411,
    width: 2,
    height: 179.75293,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.36926,
    y: 324.11002,
    width: 2,
    height: 77.00702,
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.34631,
    y: 296.2811,
    width: 2,
    height: 179.75293,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.00558,492.57016H440.04122a9.67047,9.67047,0,0,1-9.65933-9.65933V257.90505a9.67013,9.67013,0,0,1,9.65933-9.65935H823.00558a9.6702,9.6702,0,0,1,9.65936,9.65933v225.0058A9.67054,9.67054,0,0,1,823.00558,492.57016Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#e6e7e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M775.88192,492.57016h-337a8.50981,8.50981,0,0,1-8.5-8.5v-198a8.50947,8.50947,0,0,1,8.5-8.5h337a8.50951,8.50951,0,0,1,8.5,8.5v198A8.50983,8.50983,0,0,1,775.88192,492.57016Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M870.38192,574.07025h-530a8.50983,8.50983,0,0,1-8.5-8.5v-77a8.50982,8.50982,0,0,1,8.5-8.5h530a8.50982,8.50982,0,0,1,8.5,8.5v77A8.50981,8.50981,0,0,1,870.38192,574.07025Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 298.46684,
    y: 303.78089,
    width: 206,
    height: 54,
    rx: 8,
    fill: "#5165fb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 601.96687,
    cy: 306.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.96687,
    cy: 306.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.96687,
    cy: 306.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.96687,
    cy: 329.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.96687,
    cy: 329.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.96687,
    cy: 329.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.96687,
    cy: 352.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.80739,
    cy: 317.36414,
    r: 9,
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.80739,
    cy: 340.36414,
    r: 9,
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 784.69777,
    cy: 183.202,
    r: 19.23499,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.10182,
    cy: 317.36414,
    r: 9,
    fill: "#2f2e41"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.10182,
    cy: 340.36414,
    r: 9,
    fill: "#2f2e41"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.96687,
    cy: 352.28089,
    r: 9,
    fill: "#2f2e41"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.96687,
    cy: 352.28089,
    r: 9,
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M868.88192,654.57025h-531a8.50983,8.50983,0,0,1-8.5-8.5v-42a8.50982,8.50982,0,0,1,8.5-8.5h531a8.50982,8.50982,0,0,1,8.5,8.5v42A8.50981,8.50981,0,0,1,868.88192,654.57025Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M468.88186,321.07019h285a8,8,0,0,1,8,8V469.58863a8,8,0,0,1-8,8h-285a8,8,0,0,1-8-8V329.07019A8,8,0,0,1,468.88186,321.07019Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.61101,
    cy: 150.6745,
    r: 15.31303,
    fill: "#5165fb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M583.48745,387.0517H511.52312a4.55992,4.55992,0,0,1-.02-9.11981h71.98432a4.55991,4.55991,0,1,1,.0119,9.11981Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M546.24953,405.07016H511.52309a4.56014,4.56014,0,0,1-.01382-9.12027h34.7402a4.56014,4.56014,0,0,1,0,9.12027Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M715.48745,440.0517H521.52309a4.55991,4.55991,0,0,1-.0119-9.11981H715.48745a4.55991,4.55991,0,1,1,.0119,9.11981h-.0119Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M678.24953,458.07016H521.52309a4.56014,4.56014,0,0,1,0-9.12027H678.24953a4.56014,4.56014,0,0,1,0,9.12027Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.99619,647.28211l-.99772-22.43415a72.45571,72.45571,0,0,0-33.79564-8.555c16.23147,13.27045,14.203,38.85126,25.20758,56.69684a43.582,43.582,0,0,0,31.95921,20.13989l13.58305,8.31647a73.02973,73.02973,0,0,0-15.39283-59.17883,70.542,70.542,0,0,0-12.96441-12.04609C191.34223,638.7992,186.99619,647.28211,186.99619,647.28211Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.19655,456.80661a9.76007,9.76007,0,0,0,2.00589-14.83108l32.38712-71.76581-17.95819,1.53778L248.8315,441.742a9.81312,9.81312,0,0,0,12.365,15.06463Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M320.0371,302.75043l-8.58353-10.21252s-4.89257-.71625-14.41189,13.39321c-9.36987,13.88794-23.48248,43.366-16.10745,47.55384l-32.736,69.91748,20.87851,9.86282L304.276,357.78241l15.6059-21.2348Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "182.344 225.202 242.344 224.202 247.344 183.202 182.344 183.202 182.344 225.202",
    fill: "#9e616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.812 476.034 251.663 476.033 258.253 422.606 237.81 422.607 237.812 476.034",
    fill: "#9e616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "149.568 475.847 163.419 475.75 169.634 422.278 151.62 426.411 149.568 475.847",
    fill: "#9e616a"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.89 147.893 189.752 156.053 190.379 164.213 251.804 185.488 248.756 149.776 241.851 141.616 192.89 147.893",
    fill: "#ffb6b6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.24153,
    cy: 52.52147,
    r: 21.93835,
    fill: "#9e616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M356.04186,666.98993l21.89609-1.30688v9.38122l20.8172,14.37714a5.85985,5.85985,0,0,1-3.32977,10.682H369.35726l-4.49322-9.27948-1.7544,9.27948H353.281Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M266.49477,666.83667l21.88639-1.46014.06567,9.381,20.91733,14.231a5.85987,5.85987,0,0,1-3.25492,10.705l-26.06744.18249-4.55807-9.2478-1.6894,9.2915-9.82846.06879Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.923,635.61066l10.086-80.61951,5.87287-76.921c-3-35,17.12713-75.079,17.12713-75.079l7.87287-34.921L366.02264,415.052l-.01365-.06082c12.93067,35.26813,17.21476,52.69132,16.50614,90.24845L379.9677,640.24951h.79914a5,5,0,0,1,0,10h-25a5,5,0,0,1,0-10h.64459L333.46447,479.493,314.009,546.99121l-22,88c8-2,6.75785,2.634,6.75785,5.25837a5,5,0,0,1-5,5h-25a4.99479,4.99479,0,0,1-1.84387-9.63886Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M295.08639,405.61637l2.00006-20a3.98666,3.98666,0,0,1,3.6051-2.99482c.83331-9.52728,4.33936-50.62872,4.54883-52.42126l.00818-.07581,1.5943-34.05774a5.03657,5.03657,0,0,1,4.70251-4.79034l8.42078-.55041a.44562.44562,0,0,0,.4306-.44532,7.08137,7.08137,0,0,1,7.0813-7.08142h24.93121a6.63,6.63,0,0,1,6.57563,5.80383.44012.44012,0,0,0,.448.39612l.003-.00006a11.84463,11.84463,0,0,1,11.91547,9.82434c3.40839,19.831,3.23907,82.83985-.13812,107.86219-1.17566,8.71069,1.3587,1.81158,1.80328,9.09979a5.36476,5.36476,0,0,1-1.33563,3.88959c2.058.598,2.8562,2.82131,2.32812,4.91616l.43821-.10849a4,4,0,0,1-4.85639,2.90088l-74.709-7.71341C292.73974,419.53021,294.54647,407.75846,295.08639,405.61637Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M439.22588,381.89554a9.76,9.76,0,0,1-14.7001-2.80926l-33.78388,4.90625,7.16275-16.53956,30.96482-2.06747a9.81312,9.81312,0,0,1,10.35647,16.51Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#9e616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.43548,318.10184s3.86706-21.38184-7.542-24.34146-17.47686,16.21728-17.47686,16.21728c-9.19165,28.34092-10.29709,47.86377-.53473,55.53522l-.19174,19.91608s71.47448,1.79849,65.56933-2.53214-.25137-16.5769-.25137-16.5769L380.763,361.6352l2.2826-5.28721-2.39548.46039-1.71964-5.397Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.37586,265.59032q-6.07047-5.27258-12.13739-10.55418a15.25817,15.25817,0,0,1,4.46672-2.39365c5.94661-1.97829,12.39166-.22449,18.57146.749,6.18884.977,13.38469.82111,17.60454-3.8016,4.38589-4.80712,3.65216-12.14687,4.099-18.62735.61319-9.04633,4.198-18.006,10.64346-24.37467s15.83929-9.89331,24.795-8.49409c8.95215,1.40816,17.08521,8.048,19.49869,16.7763A14.97414,14.97414,0,0,1,339.63753,229.229c.0185,3.4185-1.3443,6.99085-4.14556,8.95763s-7.09232,1.85025-9.34006-.73908l3.27557-3.51713c-5.74789-.2733-12.6499,7.60066-14.05475,13.18451-1.41028,5.5713-.13888,11.43763,1.30155,17.00639s3.07019,11.264,2.3851,16.97476c-.983,8.21457-6.81473,15.32364-14.02695,19.38361s-15.66092,5.41852-23.9314,5.60956a93.7324,93.7324,0,0,1-18.4819-1.40021c1.78092-1.56711,3.5528-3.13773,5.33371-4.70484L253.134,302.52008c-2.40359-.68493-4.78979-1.467-7.14053-2.3392-6.838-2.55307-13.4853-5.988-18.635-11.143-5.15493-5.16748-8.68566-12.2445-8.41976-19.5345a19.56935,19.56935,0,0,1,1.52684-6.84626Q229.42237,264.11922,238.37586,265.59032Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.3991,229.5725c-3.14569-2.45314-7.22009-3.38365-11.19357-3.736-6.909-6.59026-10.57712-9.61813-19.70429-6.81438s-12.31122,12.33518-16.252,21.032c-9.44721,20.84866,18.63269,40.016,32.63269,30.016-3.295-3.04223,2.64877-12.75625,3.48715-17.16183a13.56155,13.56155,0,0,1,5.7478-8.58559c3.33854,1.86772,8.07407-.51015,9.22422-4.21542C369.52352,236.29753,367.54473,232.02564,364.3991,229.5725Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.665,701.02069a1.18648,1.18648,0,0,0,1.18293,1.19H1077.145a1.19,1.19,0,0,0,0-2.38H122.855a1.18647,1.18647,0,0,0-1.19,1.18286v.00714Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M775.88192,699.89932h-337c-4.69217-.00332-8.49457-2.32443-8.5-5.18873V650.759c.0054-2.86431,3.80783-5.18542,8.5-5.18874h337c4.6922.00332,8.49457,2.32443,8.5,5.18874v43.9516C784.37649,697.57489,780.57412,699.896,775.88192,699.89932Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M749.88189,689.89932h-285c-4.41828,0-8-2.17074-8-4.84847V622.91866c0-2.67773,3.58172-4.84847,8-4.84847h285c4.41827,0,8,2.17074,8,4.84847v62.13219C757.88189,687.72858,754.30016,689.89932,749.88189,689.89932Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M506.48241,652.49039H700.44665a4.55991,4.55991,0,0,1,.0119,9.11981H506.48235a4.55992,4.55992,0,0,1-.02337-9.11981h.02343Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72027,634.47183H700.44665a4.56015,4.56015,0,0,1,.00091,9.1203H543.72027a4.56013,4.56013,0,1,1-.01953-9.12024h.01953Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M332.97985,218.07c-3.5152,5.14936-7.42059,10.86254-13.615,12.94788a1.53488,1.53488,0,0,0-1.04767,1.84518,1.51482,1.51482,0,0,0,1.84519,1.04766c7.01855-2.36276,11.40737-8.46622,15.40792-14.32656a1.50024,1.50024,0,0,0-2.59042-1.51414h0Z",
    transform: "translate(-121.66502 -197.7893)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 785.90931,
    y: 184.12754,
    width: 2,
    height: 280.13303,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 803.93275,
    y: 216.984,
    width: 2,
    height: 280.13301,
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 821.39635,
    y: 214.9254,
    width: 2,
    height: 261.18462,
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 279.80407,
    y: 281.51773,
    width: 463.99388,
    height: 2,
    fill: "#2f2e41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 279.80407,
    y: 376.51773,
    width: 463.99388,
    height: 2,
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCopy);
export default __webpack_public_path__ + "static/media/illustration_copy.f75922f7805de5b0c0ebaeb6905bb466.svg";
export { ForwardRef as ReactComponent };